;(function (global, factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        factory(module, global);
    } else {
        factory({}, global);
    }
})(window || this, function (module, window) {

    //读取cookies
    function getCookie(name) {
        var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");

        if( arr=document.cookie.match(reg)) {
            return decodeURIComponent(arr[2]);
        } else{
            return '';
        }
    }
    // 获取url参数
    function getQueryString( name ) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = decodeURIComponent(window.location.search).substr(1).match(reg);
        if (r != null)
            return unescape(r[2]);
        return null;
    }
    // 发送scheme
    function scheme(url){
        var ifr = document.createElement('iframe');
        ifr.src = url;
        ifr.style.display = 'none';
        document.body.appendChild(ifr);
    }
    // 是否数组
    function isArray( arr ){
        return Object.prototype.toString.call(arr) === '[object Array]';
    }
    // 数组是否包含某元素
    function isInArray(arr, str){
        return arr.indexOf(str) >= 0;
    }
    // forEach
    if( !Array.prototype.forEach ) {
        Array.prototype.forEach = function(fun){
            for (var i=0, len=this.length; i < len; i++){
                fun && fun.call( this[i], i, this);
            }
        };
    }
    // url
    function toUrlParam( data ){
        var arr = [];
        for(var i in data){
            arr.push(encodeURI(i) + '=' + encodeURIComponent(data[i]));
        }
        return arr.join('&').replace(' ', '');
    }

    // api-2.0.js
    var chelunJSBridge = {
        callbackIndex: 0,
        callbackPrefix: '__MCL_CALLBACK_',
        schema: 'chelunJSBridge',
        invoke: function (namespace, api, param) {
            namespace = String(namespace);
            api = String(api);
            var url = this.schema + '://' + namespace + '/' + api;
            if (param && typeof param === 'object') {
                url += this._buildQuery(param);
            }

            this._sendRequest(url);
        },
        _buildQuery: function (param) {
            var seg = [], frag = '', uriSeg = '';
            for (var attr in param) {
                if (param.hasOwnProperty(attr)) {
                    if (param[attr] && typeof param[attr] === 'function') {
                        var callbackNo = this._createCallbackNo(param[attr]);
                        if (attr === 'callback') {
                            frag = '#' + callbackNo;
                        } else {
                            seg.push(encodeURIComponent(attr) + '=' + callbackNo);
                        }

                    } else {
                        var paramValue = String(param[attr]);
                        seg.push(encodeURIComponent(attr) + '=' + encodeURIComponent(paramValue));
                    }
                }
            }

            seg.length && (uriSeg += '?' + seg.join('&'));
            return uriSeg += frag;

        },
        //生成回调号
        _createCallbackNo: function (fn) {
            var callbackNo = this.callbackIndex;
            window[this.callbackPrefix + callbackNo] = fn;
            this.callbackIndex += 1;
            return callbackNo;
        },
        //发送客户端调用请求
        _sendRequest: function (uri) {
            var i = document.createElement('iframe');
            i.style.display = 'none';
            i.onload = function () {
                i.parentNode.removeChild(i);
            };
            i.src = uri;
            document.body.appendChild(i);
        }
    };
    // 返回结果
    function _result(param, res){
        if( res.result == 1 ){
            param && param.success && param.success(res);
        }else{
            param && param.fail && param.fail(res);
        }
    }

    function app(){
        this._const = {
            SHOW_MENU:          'CHELUN_SHOW_OPTION_MENU',      //是否显示右上角菜单按钮
            MENU_ITEMS:         'CHELUN_SHOW_MENU_ITEMS',       //显示的功能按钮列表
            SHARE_CLMESSAGE:    'HELUN_SHARE_DATA_CLMESSAGE',   //车轮车友分享内容
            SHARE_WXTIMELINE:   'CHELUN_SHARE_DATA_WXTIMELINE', //微信朋友圈分享内容
            SHARE_WXMESSAGE:    'CHELUN_SHARE_DATA_WXMESSAGE',  //微信朋友分享内容
            SHARE_QQ:           'CHELUN_SHARE_DATA_QQ',         //QQ好友分享内容
            SHARE_SINA:         'CHELUN_SHARE_DATA_SINA',       //新浪微博分享内容
            SHARE_SMS:          'CHELUN_SHARE_DATA_SMS',        //发短信内容
            CUSTOM_CONFIG:      'CHELUN_CUSTOM_CONFIG',         //自定义配置
            DISSYS_URLLIST:     'CHELUN_DISSYS_URLLIST'         //禁止拼系统参数的url配置列表
        };

        this._init();
    }

    /**
     * 初始化
     */
    app.prototype._init = function(){
        // 是否车轮app
        this.isApp = function () {
            var appName = (getCookie('chelun_appName') || '').toLowerCase();
            if( !appName )
                return false;
            return isInArray(['chelun', 'queryviolations', 'chelunwelfare', 'drivingtest'], appName);
        }();

        // app名
        this.appName = getCookie('chelun_appName');

        // app版本号
        this.appVersion = getCookie('chelun_appVersion');

        // 手机机型
        this.appDevice = getCookie('chelun_device');

        // 手机操作系统
        this.os = getCookie('chelun_osType')
        this.appOs = getCookie('chelun_osType') + getCookie('chelun_osVersion');

        this.appChannel = getCookie('chelun_appChannel')
        this.systemVersion = getCookie('chelun_systemVersion')

        // 车轮统一登录态
        this.acToken =  getQueryString('ac_token') || getCookie('chelun_acToken');

        // 是否登录
        this.isLogin = this.acToken ? true : false;  // getCookie('chelun_isLogin')
    };

    /**
     * 版本号转数字
     */
    app.prototype.versionToInt = function( v ){
        var maxLen = 4;

        var num = v.toString().replace(/\./g, '');
        var needLen = maxLen - Math.min(num.length, maxLen);

        return parseInt('' + num + new Array(needLen + 1).join('0') );
    };

    /**
     * 隐藏右上角菜单 ?
     */
    app.prototype.hideMenu = function(){
        window[ this._const.SHOW_MENU ] = 0;
    };

    /**
     * 显示右上角菜单 ?
     */
    app.prototype.showMenu = function(){
        window[ this._const.SHOW_MENU ] = 1;
    };

    /**
     * 设置右上角菜单
     * @param arr Array
     * 车轮车友 menu:share:clMessage
     * 微信好友 menu:share:wxMessage
     * 微信朋友圈 menu:share:wxTimeline
     * 腾讯QQ menu:share:qq
     * 新浪微博 menu:share:sina
     * 短信 menu:share:sms
     * 复制链接 menu:copyUrl
     * 浏览器打开 menu:openWithBrowser
     * 刷新 menu:refresh
     */
    app.prototype.setMenu = function( arr ){
        var _self = this;
        if( arr && isArray(arr) ){
            window[ _self._const.MENU_ITEMS ] = arr;
        }
    };

    /**
     * 添加右上角菜单
     * @param arr Array 同setMenu参数
     */
    app.prototype.addMenu = function( arr ){
        var _self = this;
        if( arr && isArray(arr) ){
            window[ _self._const.MENU_ITEMS ] = window[ _self._const.MENU_ITEMS ] || [];
            arr.forEach(function(val) {
                if( !isInArray(window[_self._const.MENU_ITEMS], val) ) {
                    window[ _self._const.MENU_ITEMS ].push(val);
                }
            });
        }
    };

    /**
     * 唤醒APP登录
     * @param param Object
     * success 成功
     * fail  失败
     */
    app.prototype.login = function( param ){
        chelunJSBridge.invoke('app', 'login', {
            'tj_from': param.tj_from || '',
            'loginCallBackName': function (res) {
                _result(param, res);
            },
            callback : function(res){}
        });
    };
     
    /**
     * 打开系统浏览器
     * @param url String
     */
    app.prototype.openWithBrowser = function( param ){
        chelunJSBridge.invoke('ui', 'openWithBrowser', {
            'url': param.url,
            callback : function(res){}
        });
    };

    /**
     * 设置右上角菜单分享
     * @param param
     * title
     * timeline
     * desc
     * imgUrl
     * link
     */
    app.prototype.setMenuShare = function( param ){
        window.shareData = {
            fTitle:     param.title,
            fContent:   param.desc,
            fImgUrl:    param.imgUrl,
            fLink:      param.link,

            tTitle:     param.timeline,
            tContent:   param.desc,
            tImgUrl:    param.imgUrl,
            tLink:      param.link

        };

        // 兼容老版ios app
        function onBridgeReady() {
            WeixinJSBridge.on('menu:share:appmessage', function(argv) {
                var data = {
                    title:      window.shareData.fTitle,
                    desc:       window.shareData.fContent,
                    img_url:    window.shareData.fImgUrl,
                    link:       window.shareData.fLink,
                    type:       'link',
                    content:    '',
                    img_width:  "200",
                    img_height: "200"
                };
                WeixinJSBridge.invoke("sendAppMessage", data, function(res) {
                    WeixinJSBridge.log(res.err_msg);
                });
            });

            WeixinJSBridge.on("menu:share:timeline", function(e) {
                var data = {
                    title:      window.shareData.tTitle,
                    desc:       window.shareData.tContent,
                    img_url:    window.shareData.tImgUrl,
                    link:       window.shareData.tLink,
                    img_width: "200",
                    img_height: "200"
                };
                WeixinJSBridge.invoke("shareTimeline", data, function(res) {
                    WeixinJSBridge.log(res.err_msg);
                });
            });
        }

        try{
            if(typeof WeixinJSBridge === "undefined"){
                if (document.addEventListener){
                    document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                }
                else if(document.attachEvent){
                    document.attachEvent('WeixinJSBridgeReady' , onBridgeReady);
                    document.attachEvent('onWeixinJSBridgeReady' , onBridgeReady);
                }
            }
            else{
                onBridgeReady();
            }
        }catch(e){}

        // 兼容新版Android app  有问题?
        window[this._const.SHARE_WXMESSAGE] = {
            title:  param.title,
            desc:   param.desc,
            imgUrl: param.imgUrl,
            link:   param.link
        };
        window[this._const.SHARE_WXTIMELINE] = {
            title:  param.timeline,
            imgUrl: param.imgUrl,
            link:   param.link
        };
        // 发送给qq
        window[this._const.SHARE_QQ] = {
            title:  param.title,
            desc:   param.desc,
            imgUrl: param.imgUrl,
            link:   param.link
        };
        // 微博
        window[this._const.SHARE_SINA] = {
            title:  param.title,
            desc:   param.desc,
            imgUrl: param.imgUrl,
            link:   param.link
        };
    };
     /**
      * 
      */
     app.prototype.shareWx = function( param ){
        // 分享到朋友圈
        window[this._const.SHARE_WXTIMELINE] = {
            title:  param.timeline,
            imgUrl: param.imgUrl,
            link:   param.link
        };
        console.info('scheme %o', param);
        chelunJSBridge.invoke('ui', 'shareMessage', {
            'to': 'wxTimeline',
            'shareCallBackName': function (res) {
                _result(param, res);
            },
            callback : function(res){}
        });
    };

    /**shareConfig 方法
      *ditch 渠道分享至
      *ditch参数
      *微信好友:wxMessage
      *微信朋友圈:wxTimeline
      *腾讯QQ:qq
      *新浪微博:sina
      */
     app.prototype.shareConfig = function( param ){
        // 微信好友
        window[this._const.SHARE_WXMESSAGE] = {
            title:  param.title,
            desc:   param.desc,
            imgUrl: param.imgUrl,
            link:   param.link
        };
        // 朋友圈
        window[this._const.SHARE_WXTIMELINE] = {
            title:  param.timeline,
            imgUrl: param.imgUrl,
            link:   param.link
        };
        // 发送给qq
        window[this._const.SHARE_QQ] = {
            title:  param.title,
            desc:   param.desc,
            imgUrl: param.imgUrl,
            link:   param.link
        };
        // 微博
        window[this._const.SHARE_SINA] = {
            title:  param.title,
            desc:   param.desc,
            imgUrl: param.imgUrl,
            link:   param.link
        };
        console.info('scheme %o', param);
        chelunJSBridge.invoke('ui', 'shareMessage', {
            'to': param.ditch,
            'shareCallBackName': function (res) {
                _result(param, res);
            },
            callback : function(res){}
        });
    };

    /**
     * 弹出菜单分享
     * @param param
     * title
     * timeline
     * desc
     * imgUrl
     * link
     * success
     * fail
     */
    app.prototype.share = function( param ){
        this.showMenu();
        this.addMenu(['menu:share:wxMessage', 'menu:share:wxTimeline', 'menu:refresh']);

        // 发送给微信好友
        window[this._const.SHARE_WXMESSAGE] = {
            title:  param.title,
            desc:   param.desc,
            imgUrl: param.imgUrl,
            link:   param.link
        };
        // 分享到朋友圈
        window[this._const.SHARE_WXTIMELINE] = {
            title:  param.timeline,
            imgUrl: param.imgUrl,
            link:   param.link
        };
        // 发送给qq
        window[this._const.SHARE_QQ] = {
            title:  param.title,
            desc:   param.desc,
            imgUrl: param.imgUrl,
            link:   param.link
        };
        console.info('scheme %o', param);
        chelunJSBridge.invoke('ui', 'shareMessage', {
            'shareCallBackName': function (res) {
                _result(param, res);
            },
            callback : function(res){}
        });

        // 兼容ios app
        /*var isIos = /iphone|ipad/i.test( navigator.userAgent );
        if( isIos ) {

            var shareData = {
                /!*好友标题*!/
                "shareTitle": param.title,
                /!*好友描述、朋友圈标题*!/
                "shareSummary": param.timeline || param.desc,
                "shareImgUrl": param.imgUrl,
                "shareUrl": param.link,

                /!*app分享框*!/
                "title": "分享到",
                "summary":  '',
                "advanceMode": 'false'
            };

            window.location.href = "kaojiazhao://share/?" + toUrlParam(shareData);
        }else{
            chelunJSBridge.invoke('ui', 'shareMessage', {
                'shareCallBackName': function (res) {
                    _result(param, res);
                },
                callback : function(res){}
            });
        }*/
    };

    /**
     * 查询某个应用是否已安装
     * @param param Object
     * os
     * name
     */
    app.prototype.isAppInstalled = function( param ){
        console.log(param)
        chelunJSBridge.invoke('app', 'isAppInstalled', {
            'isAppInstalledCallBackName': function (res) {
                console.log('isAppInstalled()', res)
                _result(param, res);
            },
            callback : function(res){}
        });
    };


    /**
     * 绑定教练
     */
    app.prototype.bindCoach = function(){
        scheme('driving://apply/bindCoach');
    };

    /**
     * 唤起app 支付
     * @param param Object
     * os
     * name
     */
    app.prototype.appPay = function( param ){
        chelunJSBridge.invoke('app', 'pay', {
            'price': param.price,
            'orderNum': param.orderNum,
            'channels': param.channels,
            'callbackUrl': param.callbackUrl,
            
            'payCallback': function (res) {
                _result(param, res);
            },
            callback : function(res){}
        });
    };
    
    /**
     * 刷新
     * @无需返回值
     *
     */
    app.prototype.refresh = function( param ){
        chelunJSBridge.invoke('ui', 'refresh');
    };

    /**
     * 修改标题
     * 
     *
     */
    app.prototype.settitle = function( param ){
        chelunJSBridge.invoke('ui', 'setTitle', {
            'title': param
        });
    };

    /**
     * 复制文字到剪切版
     */
    app.prototype.appCopy = function( param ){
        chelunJSBridge.invoke('ui', 'copy', {
            'text': param.text,
            callback : function(res){
                _result(param, res);
            }
        });
    };
    
    /**
     * 获取经纬度
     */
    app.prototype.getPoint = function( param ){
        chelunJSBridge.invoke('device', 'getLocation', {
            'locationCallBackName': function (res) {
                _result(param, res);
            },
            callback : function(res){}
        });
    };


    /**
     * 上传图片
     */

    app.prototype.uploadImage = function (param) {
        chelunJSBridge.invoke('device', 'chooseImage', {
            'type': param.type,
            'chooseCallbackName': function (res) {
                // alert(res);
                _result(param, res);
            },
            callback : function(res){}
        })
    }

    /**
     * 保存图片
     */
    app.prototype.SavePic = function(param){
        chelunJSBridge.invoke('data', 'SavePic', {
            'url': param.url,
            'SavePicCallbackName': function (res) {
                console.info('app回调', res)
               _result(param, res);
           },
        });
    }

    /**
     * 绑定微信
     */
     app.prototype.bindWeixin = function(param){
     	console.info('bindWeixin', param)
     	chelunJSBridge.invoke('ui', 'bindWeixin', {
	 		'bindCallBackName': function (res) {
	            _result(param, res);
	        },
     	});
     }
     /**
     * 获取app题目配置
     */
     app.prototype.getQuestions = function(param){
     	console.info('getQuestions', param)
     	chelunJSBridge.invoke('ui', 'getQuestions', {
     		'mode': param.mode || 'no', // 'answerContain'
     		'number': param.number || 10, // 题目数
     		'course': param.course || 1, // 科目
     		'cert': param.cert || 1,  // 车型
	 		'getQuestionCallbackName': function (res) {
	 			console.info('app回调', res)
	            _result(param, res);
	        },
     	});
     }

     /**
     * 获取工具栏状态通知
     */

    app.prototype.getNotice = function(param){
        chelunJSBridge.invoke('tool', 'getNotice', {
            'getNoticeCallbackName': function (res) {
                console.info('getNotice', res)
               _result(param, res);
           },
        });
    }

    /**
     * 设置工具栏状态通知
     */

    app.prototype.setNotice = function(param){
        chelunJSBridge.invoke('tool', 'setNotice', {
            'setNoticeCallbackName': function (res) {
                console.info('setNotice', res)
               _result(param, res);
           },
        });
    }

    /**
     * 驾考通绑定微信权限信息
     * 1.头像 headimgurl
     * 2.昵称 nickname
     * 3.unionid
     * 4.openid
     */
    app.prototype.kjzBindWeixin = function(param){
        console.info('impower_kjzBindWeixin', param)
        chelunJSBridge.invoke('impower', 'kjzBindWeixin', {
            'bindCallBackName': function (res) {
                _result(param, res);
            },
        });
     }

    window._kjz = module.exports = new app();
});





//////////////////
// WEBPACK FOOTER
// ./static/js/chelun-kjz.js
// module id = 6Lgn
// module chunks = 1